import { createApp } from 'vue';
import { createPinia } from 'pinia';

import './init/import-supertokens';
import './init/import-css';
import { applyPrimeVue } from './init/import-primevue';
import { createRouterObject } from './router/router';
import App from './App.vue';

const app = createApp(App);
const router = createRouterObject();

applyPrimeVue(app);
app.use(createPinia());
app.use(router);

app.mount('#app');
